import { getUnprefixedLocalStorageItem, removeUnprefixedLocalStorageItem } from '@/utils/storage'

const ACCESS_TOKEN_KEYS = ['siswe_access_token', 'chat3d_access_token', 'chat3d_token', 'token'] as const
const REFRESH_TOKEN_KEYS = ['siswe_refresh_token', 'chat3d_refresh_token'] as const

export function getUnifiedAccessToken() {
  return ACCESS_TOKEN_KEYS.map(getUnprefixedLocalStorageItem).find(Boolean) ?? ''
}

export function clearUnifiedSession() {
  ACCESS_TOKEN_KEYS.forEach(removeUnprefixedLocalStorageItem)
  REFRESH_TOKEN_KEYS.forEach(removeUnprefixedLocalStorageItem)
  localStorage.removeItem('account')
  localStorage.removeItem('avatar')
}

export function redirectToAccountCenter(returnTo = `${window.location.pathname}${window.location.search}${window.location.hash}`) {
  const accountURL = new URL('/account/' || '/account/', window.location.origin)
  const requested = new URL(returnTo, window.location.origin)
  if (requested.origin === window.location.origin && !requested.pathname.startsWith('/account')) {
    accountURL.searchParams.set('returnTo', `${requested.pathname}${requested.search}${requested.hash}`)
  }
  window.location.replace(accountURL.href)
}
